import { inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, objectSpread as _objectSpread } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './tile.css.js';
var clickableTags = ['input', 'label', 'button', 'a'];

var Tile = /*#__PURE__*/function (_Component) {
  _inherits(Tile, _Component);

  function Tile(props) {
    var _this;

    _classCallCheck(this, Tile);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tile).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focussed: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      if (_this.tile.current.contains(event.target) && !clickableTags.includes(event.target.tagName.toLowerCase()) && !clickableTags.includes(event.target.parentNode.tagName.toLowerCase())) {
        _this.props.onChange({
          value: !_this.props.selected,
          event: event
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      if (event.target.tagName.toLowerCase() === 'input') {
        _this.setState({
          focussed: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      if (event.target.tagName.toLowerCase() === 'input') {
        _this.setState({
          focussed: false
        });
      }
    });

    _this.tile = React.createRef();
    return _this;
  }

  _createClass(Tile, [{
    key: "render",
    value: function render() {
      var _cn;

      var _this$props = this.props,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["children"]);

      var focussed = this.state.focussed;
      return (// We choose to disable these errors because this onClick handler has the same functionality as the onChange handler
        // which is attached to the input
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        React.createElement("div", {
          onClick: this.handleClick,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          className: cn(styles.Tile, (_cn = {}, _defineProperty(_cn, styles.selectedTile, rest.selected), _defineProperty(_cn, styles.invalidTile, rest.invalid), _defineProperty(_cn, styles.hasFocus, focussed), _cn)),
          ref: this.tile
        }, children(_objectSpread({}, rest, {
          focussed: focussed
        })))
      );
    }
  }]);

  return Tile;
}(Component);

Tile.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  selected: PropTypes.bool,
  invalid: PropTypes.bool,
  children: PropTypes.func.isRequired
} : {};
export default Tile;